window.$ = window.jQuery = require('jquery');
require('popper.js');
require('bootstrap');

import 'intersection-observer/intersection-observer.js';
IntersectionObserver.prototype.POLL_INTERVAL = 100;

import Vue from 'vue';
import VueObserveVisibility from 'vue-observe-visibility/dist/vue-observe-visibility'
import DynamicImage from './components/DynamicImage.vue';
import VisibilityChangeAnnouncer from './visibility-change-announcer.js';
import DynamicDisease from './components/DynamicDisease.vue';
import Quiz from './components/Quiz.vue';
import QuizResponseChart from './components/QuizResponseChart.vue'

Vue.use(VueObserveVisibility);

// Bootstrap carousel doesn't work very well with the IntersectionObserver polyfill.
// Listen specifically for this event.
VisibilityChangeAnnouncer.registerEvent("slid.bs.carousel");

const app = new Vue({
    el: '#app',
    //components: { DynamicImage}
    components: { DynamicImage, DynamicDisease, Quiz, QuizResponseChart}

});



// WEBPACK FOOTER //
// ./resources/assets/js/public.js